import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'

import FileListItem from 'modules/tasks/components/FileListItem'

interface Props {
  fileName: string
}

const New = ({ fileName }: Props) => {
  return (
    <BoxList>
      <FileListItem fileName={fileName} uploading options={[]} />
    </BoxList>
  )
}

export default observer(New)
